(function () {
  function handleUpgradeClick(e) {
    const btn = e.target.closest('.upgrade-button');
    if (!btn) return;

    // Empêche toute logique du thème qui pourrait fermer le drawer
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const line = btn.dataset.drawerLine;
    if (!line) return;

    const row = document.getElementById(`CartDrawer-Item-${line}`);
    if (!row) return;

    // Le plus fiable : simuler un clic sur le bouton "+" natif
    const plusBtn = row.querySelector('button[name="plus"]');
    if (plusBtn) {
      plusBtn.click();
      return;
    }

    // Fallback si jamais le thème change
    const input = row.querySelector('input.quantity__input');
    if (input) {
      const current = parseInt(input.value || '0', 10);
      input.value = String(current + 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Capture = on passe avant les listeners du thème
  document.addEventListener('click', handleUpgradeClick, true);
})();
